"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleTemplates = exports.layoutTemplates = exports.keyToI18n = exports.keyToEmoji = exports.moduleDefaults = exports.pollDefaults = void 0;
exports.pollDefaults = {
    base: {
        language: 'es',
    }
};
exports.moduleDefaults = {
    base: {
        type: 'question',
        metadata: {
            settings: {
                maxMotivos: 1,
                commentEnabled: false,
                allowScoreNA: false,
                motivesLayout: 'default',
                randomMotives: false,
                break: false,
                required: true,
                rules: [],
                score: {
                    order: 'ascend',
                    scale: 'nps',
                    min: 1,
                    max: 10,
                    best: undefined,
                    worst: undefined,
                    showLabels: false,
                },
            },
            strings: {
                motivosTitle: 'main-reason-opinion',
                footerMotives: '',
            },
        },
    },
    boolean: {
        metadata: {
            settings: {
                score: {
                    order: 'descend',
                    layout: 'buttons',
                    scale: 'boolean',
                    min: 0,
                    max: 1,
                    labels: ['No', 'Sí'],
                },
            },
        },
    },
    smiles: {
        metadata: {
            settings: {
                score: {
                    order: 'descend',
                    layout: 'smiles',
                    scale: 'nps',
                    min: 1,
                    max: 4,
                },
            },
        },
    },
    csat: {
        metadata: {
            settings: {
                score: {
                    layout: 'options',
                    scale: 'csat',
                    labels: [
                        'Muy insatisfecho',
                        'Insatisfecho',
                        'Neutro',
                        'Satisfecho',
                        'Muy satisfecho',
                    ],
                    max: 5,
                },
            },
        },
    },
    ces: {
        metadata: {
            settings: {
                score: {
                    layout: 'options',
                    scale: 'ces',
                    labels: [
                        'Muy insatisfecho',
                        'Insatisfecho',
                        'Neutro',
                        'Satisfecho',
                        'Muy satisfecho',
                    ],
                    max: 5,
                },
            },
        },
    },
    numeric: {
        metadata: {
            settings: {
                score: {
                    layout: 'numeric',
                    scale: 'numeric',
                    min: 0,
                },
            },
        },
    },
};
exports.keyToEmoji = {
    'smile-angry': '😡',
    'smile-bad': '🙁',
    'smile-regular': '😐',
    'smile-good': '🙂',
    'smile-excellent': '😀',
};
exports.keyToI18n = {
    'smile-angry': 'angry',
    'smile-bad': 'bad',
    'smile-regular': 'regular',
    'smile-good': 'good',
    'smile-excellent': 'excellent',
};
exports.layoutTemplates = {
    smiles_1_4: [
        'smile-bad',
        'smile-regular',
        'smile-good',
        'smile-excellent',
    ],
    smiles_1_5: [
        'smile-angry',
        'smile-bad',
        'smile-regular',
        'smile-good',
        'smile-excellent',
    ],
    smiles_1_7: [
        'smile-angry',
        'smile-bad',
        'smile-regular-bad',
        'smile-regular',
        'smile-regular-good',
        'smile-good',
        'smile-excellent',
    ],
};
exports.scaleTemplates = {
    boolean_0_1: [
        'no',
        'yes',
    ],
    ces_1_5: [
        'very-unsatisfied',
        'satisfied',
        'neither-satisfied-nor-dissatisfied',
        'unsatisfied',
        'very-unsatisfied',
    ],
    ces_1_7: [
        'very-unsatisfied',
        'satisfied',
        'somewhat-satisfied',
        'neither-satisfied-nor-dissatisfied',
        'somewhat-unsatisfied',
        'unsatisfied',
        'very-unsatisfied',
    ],
};
